import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

function loadView (view: string) {
    return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}
// function loadComponent (view: string) {
//     return () => import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
// }

const routes = [
    // {
    //     path: '/',
    //     name: 'Home',
    //     component: Home
    // },
    // {
    //     path: '/about',
    //     name: 'About',
    //     // route level code-splitting
    //     // this generates a separate chunk (about.[hash].js) for this route
    //     // which is lazy-loaded when the route is visited.
    //     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }

    // indexページ(未ログイン画面)
    {
        path: '/',
        component: loadView('Wrapper'),
        meta: { title: 'virtual-wallet', desc: 'virtual-walletはブラウザからデバイスにインストールできる仮想通貨ウォレットアプリです。', lang: 'ja' },
        children: [
            {
                path: '',
                name: 'index',
                component: loadView('Index')
            }
        ]
    },
    // よくある質問
    // 仮想通貨とは？ウォレットとは？PWAとは？安全性について？今後どうなる？
    {
        path: '/faq',
        component: loadView('Wrapper'),
        children: [
            {
                path: '',
                name: 'faq',
                component: loadView('Faq')
            }
        ]
    },
    // 使い方
    {
        path: '/howto',
        component: loadView('Wrapper'),
        children: [
            {
                path: '',
                name: 'howto',
                component: loadView('HowTo')
            }
        ]
    },
    // ウォレットについて
    {
        path: '/about',
        component: loadView('Wrapper'),
        children: [
            {
                path: '',
                name: 'about',
                component: loadView('About')
            }
        ]
    },
    // 利用規約
    {
        path: '/rules',
        component: loadView('Wrapper'),
        children: [
            {
                path: '',
                name: 'rules',
                component: loadView('Rules')
            }
        ]
    },

    // topページ(ログイン画面(ここからPWAのみアクセス可能))
    // {
    //     path: '/top',
    //     name: 'top',
    //     component: loadView('Top')
    // },
    // スタート画面
    {
        path: '/start',
        component: loadView('WrapperApp'),
        children: [
            {
                path: '',
                name: 'start',
                component: loadView('Start/Index')
            },
            {
                path: 'pin1',
                name: 'startPin1',
                component: loadView('Start/Pin1')
            },
            {
                path: 'pin2',
                name: 'startPin2',
                component: loadView('Start/Pin2')
            },
            {
                path: 'apply',
                name: 'startApply',
                component: loadView('Start/Apply')
            },
            {
                path: 'restore/mnemonic',
                name: 'startRestoreMnemonic',
                component: loadView('Start/RestoreMnemonic')
            },
            {
                path: 'restore/pin1',
                name: 'startRestorePin1',
                component: loadView('Start/RestorePin1')
            },
            {
                path: 'restore/pin2',
                name: 'startRestorePin2',
                component: loadView('Start/RestorePin2')
            },
            {
                path: 'restore/apply',
                name: 'startRestoreApply',
                component: loadView('Start/RestoreApply')
            },
        ]
    },

    // 1.ホーム
    {
        path: '/token',
        component: loadView('WrapperApp'),
        children: [
            {
                path: '',
                name: 'token',
                component: loadView('Token/Index'),
            },
            {
                path: 'setting',
                name: 'tokenSetting',
                component: loadView('Token/Setting'),
            },
        ]
    },
    // トークン情報
    {
        path: '/token/:name',
        component: loadView('WrapperApp'),
        children: [
            // 確認ページ
            {
                path: '',
                name: 'tokenInfo',
                component: loadView('Token/Info'),
            },
            {
                path: 'key',
                name: 'tokenInfoKey',
                component: loadView('Token/InfoKey'),
            },
            {
                path: 'key/pin',
                name: 'tokenInfoKeyPin',
                component: loadView('Token/InfoKeyPin'),
            },
            {
                path: 'key/show',
                name: 'tokenInfoKeyShow',
                component: loadView('Token/InfoKeyShow'),
            },
            // 送金ページ
            {
                path: 'transfer',
                name: 'tokenTransfer',
                component: loadView('Token/Transfer'),
            },
            {
                path: 'transfer/pin',
                name: 'tokenTransferPin',
                component: loadView('Token/TransferPin'),
            },
            // 受け取るページ
            {
                path: 'address',
                name: 'tokenAddress',
                component: loadView('Token/Address'),
            },
            // agentTransfer送金ページ
            {
                path: 'agent-transfer',
                name: 'tokenAgentTransfer',
                component: loadView('Token/AgentTransfer'),
            },
        ]
    },
    // 送金先
    {
        path: '/token/friends',
        component: loadView('WrapperApp'),
        children: [
            {
                path: '',
                name: 'tokenFriends',
                component: loadView('Token/FriendsIndex'),
            },
            {
                path: ':publicKey',
                name: 'tokenFriendsInfo',
                component: loadView('Token/FriendsInfo'),
            },
            {
                path: ':publicKey/transfer',
                name: 'tokenFriendsTransfer',
                component: loadView('Token/FriendsTransfer'),
            },
            {
                path: ':publicKey/transfer/pin',
                name: 'tokenFriendsTransferPin',
                component: loadView('Token/FriendsTransferPin'),
            },
            // 編集
            {
                path: 'add',
                name: 'tokenFriendsAdd',
                component: loadView('Token/FriendsAdd'),
            },
            {
                path: ':publicKey/User',
                name: 'tokenFriendsEdit',
                component: loadView('Token/FriendsEdit'),
            },
        ]
    },

    // 2.ワーク 廃止
    {
        path: '/works',
        component: loadView('WrapperApp'),
        children: [
            {
                path: '/',
                name: 'works',
                component: loadView('Works/Index'),
            },
            {
                path: 'list/:search',
                name: 'workList',
                component: loadView('Works/WorkList'),
            },
        ]
    },

    // 2.NFTビルダー
    {
        path: '/builder',
        component: loadView('WrapperApp'),
        children: [
            {
                path: '/',
                name: 'builder',
                component: loadView('Builder/Index'),
            },
            {
                path: 'create',
                name: 'builderCreate',
                component: loadView('Builder/Create'),
            },
            {
                path: 'confirm',
                name: 'builderConfirm',
                component: loadView('Builder/Confirm'),
            },
        ]
    },

    // 3.スクエア
    {
        path: '/square',
        component: loadView('WrapperApp'),
        children: [
            {
                path: '',
                name: 'square',
                component: loadView('Square/Index'),
            },
        ]
    },
    // チャット
    {
        path: '/square/chat',
        component: loadView('WrapperApp'),
        children: [
            // ログイン順ユーザーリスト
            {
                path: '',
            },
            // チャットルームリスト
            {
                path: 'chatroom',
            },
            {
                path: 'chatroom/:chatroomId',
            },
            // ユーザー
            {
                path: ':userId',
            },
            {
                path: ':userId/profile',
            },
        ]
    },

    // ゲーム
    {
        path: '/square/game',
        component: loadView('WrapperApp'),
        children: [
            // ゲームトップ
            {
                path: '',
            },
            // 各ゲームトップ
            {
                path: ':gameCode',
            },
        ]
    },

    // 4.設定
    {
        path: '/option',
        component: loadView('WrapperApp'),
        children: [
            // アカウントプロフィール＆設定メニュー
            {
                path: '',
                name: 'option',
                component: loadView('Option/Index'),
            },
            // 使い方
            {
                path: 'howto',
                name: 'optionHowto',
                component: loadView('Option/HowTo'),
            },
            // 利用規約
            {
                path: 'rules',
                name: 'optionRules',
                component: loadView('Option/Rules'),
            },
            {
                path: 'rules/works',
                name: 'optionRulesWorks',
                component: loadView('Option/RulesWorks'),
            },
            // よくある質問
            {
                path: 'faq',
                name: 'optionFaq',
                component: loadView('Option/Faq'),
            },
            // VirtualWalletについて
            {
                path: 'about',
                name: 'optionAbout',
                component: loadView('Option/About'),
            },
        ]
    },
    // アカウント情報をバックアップ
    {
        path: '/option/backup',
        component: loadView('WrapperApp'),
        children: [
            // 準備画面
            {
                path: '',
                name: 'optionBackup',
                component: loadView('Option/BackupIndex'),
            },
            // 暗証番号入力
            {
                path: 'pin',
                name: 'optionBackupPin',
                component: loadView('Option/BackupPin'),
            },
            // ニーモニック表示
            {
                path: 'mnemonic',
                name: 'optionBackupMnemonic',
                component: loadView('Option/BackupMnemonic'),
            },
        ]
    },
    // 暗証番号を再設定
    {
        path: '/option/pin',
        component: loadView('WrapperApp'),
        children: [
            // 現在の暗証番号入力準備
            {
                path: '',
                name: 'optionPin',
                component: loadView('Option/PinIndex'),
            },
            // 現在の暗証番号入力
            {
                path: 'current',
                name: 'optionPinCurrent',
                component: loadView('Option/PinCurrent'),
            },
            // 新しい暗証番号入力
            {
                path: 'reset1',
                name: 'optionPinReset1',
                component: loadView('Option/PinReset1'),
            },
            // 新しい暗証番号入力確認
            {
                path: 'reset2',
                name: 'optionPinReset2',
                component: loadView('Option/PinReset2'),
            },
        ]
    },
    // トークンインポート
    {
        path: '/option/import',
        component: loadView('WrapperApp'),
        children: [
            // 新規追加済み通貨リスト
            {
                path: '',
                name: 'optionImport',
                component: loadView('Option/ImportIndex')
            },
            // 新規追加通貨import
            {
                path: 'add',
                name: 'optionImportAdd',
                component: loadView('Option/ImportAdd')
            },
            {
                path: 'add/pin',
                name: 'optionImportAddPin',
                component: loadView('Option/ImportAddPin')
            },
            // 新規追加済み通貨編集
            {
                path: ':name',
                name: 'optionImportInfo',
                component: loadView('Option/ImportInfo')
            },
            {
                path: ':name/key',
                name: 'optionImportInfoKey',
                component: loadView('Option/ImportInfoKey')
            },
            {
                path: ':name/key/pin',
                name: 'optionImportInfoKeyPin',
                component: loadView('Option/ImportInfoKeyPin')
            },
            {
                path: ':name/key/show',
                name: 'optionImportInfoKeyShow',
                component: loadView('Option/ImportInfoKeyShow')
            },
        ]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

export default router
